import {createTagRepeat, optimizeTemplateHTML} from '../../lib/utils.js';

const calendarWeeksTemplate = optimizeTemplateHTML(`<div class="calendar-weeks">
  <div class="days-of-week"><span class="dow"></span></div>
  <div class="weeks">${createTagRepeat('span', 6, {class: 'week'})}</div>
</div>`);

export default calendarWeeksTemplate;
